<template>
  <div
    :class="{
      display_off:
        location != 'namya.app' &&
        location != 'localhost:8080' &&
        location != 'www.xn--mgba3gc68d.com',
    }"
  >
    <Navbar />
    <Filters />
    <bottommenu />
  </div>
</template>

<script>
import Navbar from "@/layouts/navbar";
import Booths from "@/components/booths/booths.vue";
import Filters from "@/components/filters/filters.vue";
import Slider from "@/components/sliders/slider.vue";
import bottommenu from "@/menuApp.vue";

export default {
  data() {
    return {
      location: window.document.location.host.replace("www.", ""),
    };
  },
  components: {
    Booths,
    Filters,
    Slider,
    Navbar,
    bottommenu,
  },
  metaInfo() {
    return {
      title: this.location == "namya.app" ? "نامیا" : "",
      titleTemplate: this.location == "namya.app" ? "%s | کسب و کار ها" : "",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.app/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content: "https://namya.app/logo.jpg",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      {
        itemprop: "image",
        content: "https://namya.app/logo.jpg",
      },
    ],
  },
};
</script>

<style>
.display_off {
  display: none;
}
</style>
